import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Button from "../Components/Button";
import Input from "../Components/Input";
import SalesLayout from "./SalesLayout";
import ComparisonFilter from "./ComparisonFilter";
import useEventComparison from "../hooks/useEventComparison";
import useEventComparisonAll from "../hooks/useEventComparisonAll";
import { exportToCSV } from "../Utility/Csv";
import {Link} from "react-router-dom";

const EventComparison = () => {
  const {
    events,
    pagy,
    setCurrentPage,
    sortFilter,
    setSortFilter,
    resetPagination,
    setSearchFilter,
    setAttendanceMin,
    setAttendanceMax,
    setGrossMin,
    setGrossMax,
  } = useEventComparison();

  const { allEvents, setSortFilterAll, setSearchFilterAll, setAttendanceMinAll, setAttendanceMaxAll, setGrossMinAll, setGrossMaxAll } =
    useEventComparisonAll();

  const sortOptions = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "Artist",
      value: "artist",
    },
    {
      label: "Venue",
      value: "name",
    },
    {
      label: "State",
      value: "state",
    },
    {
      label: "Gross Sales",
      value: "gross_sales",
    },
    {
      label: "Attendance",
      value: "attendance",
    },
  ];

  const handleSortSelect = (option) => {
    if (option.value !== sortFilter) {
      setSortFilter(option.value);
      setSortFilterAll(option.value);
      resetPagination();
      setCurrentPage(1);
    }
  };

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchFilter(searchTimeout);
      setSearchFilterAll(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setSearchFilter, setSearchFilterAll]);

  const handlePageChange = (e) => {
    setCurrentPage(e.target.value);
  };

  allEvents.map((each) => {
    if (each.gross_sales && each.attendance) {
      each.per_head = each.gross_sales / each.attendance;
    } else {
      each.per_head = 0;
    }
    return null;
  });

  const eventComparison = allEvents.map((event) => ({
    Event_Date: event.formattedDate,
    Artist: event.artist?.name,
    Venue: event.name,
    City: event.city,
    State: event.state,
    Gross_Sales: event.gross_sales,
    Attendance: event.attendance,
    Per_Head: event.per_head,
  }));

  const renderEventsTable = () => {
    return (
      <div>
        {events.length > 0 && (
          <div className="mx-12 flex justify-end text-sm pt-10">
            <Button
              className="button"
              text="Export"
              onClick={() => exportToCSV(eventComparison, "event_comparison")}
            ></Button>
          </div>
        )}
        <div className="mx-10">
          <div
            className={
              events.length === 0
                ? "text-2xl mt-7 pb-8 font-medium"
                : "text-2xl -mt-12 pb-8 font-medium"
            }
          >
            Event Comparison
          </div>
          <div className="-mt-5 mb-4 text-sm">
            <div className="flex">
              <div className="absolute mt-6 ml-2 text-black">
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </div>
              <div className="w-1/4 text-black text-xs">
                <Input
                  onChange={handleSearchChange}
                  value={searchTimeout}
                  placeholder="City or Venue Name"
                  label="SEARCH BY CITY OR VENUE"
                  bigPaddingLeft
                />
              </div>
              <div className="flex flex-col w-1/4 ml-2">
                <span className="text-xs text-black">SORT BY</span>
                <Select
                  id="sort_filter"
                  className="text-xs font-light"
                  placeholder="Select sort by..."
                  options={sortOptions}
                  onChange={handleSortSelect}
                  value={sortOptions?.filter(
                    (each) => each.value === sortFilter
                  )}
                />
              </div>
              <ComparisonFilter
                setAttendanceMin={setAttendanceMin}
                setAttendanceMax={setAttendanceMax}
                setAttendanceMinAll={setAttendanceMinAll}
                setAttendanceMaxAll={setAttendanceMaxAll}
                setGrossMin={setGrossMin}
                setGrossMax={setGrossMax}
                setGrossMinAll={setGrossMinAll}
                setGrossMaxAll={setGrossMaxAll}
                resetPagination={resetPagination}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
        {events.length > 0 ? (
          <table className="w-full">
            <thead className="text-xs font-light">
              <tr className="text-left border-b-2 h-11 w-full text-black">
                <td className="w-1/8 pl-6">DATE</td>
                <td className="w-1/6">ARTIST</td>
                <td className="w-1/6">VENUE</td>
                <td className="w-1/6">CITY</td>
                <td className="w-1/25">STATE</td>
                <td className="w-1/8 text-right">GROSS SALES</td>
                <td className="w-1/8 text-right">ATTENDANCE</td>
                <td className="w-1/25"></td>
                <td className="w-1/25 text-right pr-6">PER HEAD</td>
              </tr>
            </thead>
            <tbody>
              {events.map((eventToRender, i) => {
                return (
                  <tr key={eventToRender.id} className="border-b text-sm h-11">
                    <td className="pl-6 text-blue-500" id={`date_${i}`}>
                      <Link
                        to={`/sales/events/${eventToRender.id}/details/`}
                      >
                        {eventToRender.formattedDate}
                      </Link>
                    </td>
                    <td id={`artist_${i}`} className="text-blue-500">
                      <Link
                        to={`/artists/${eventToRender?.artist?.id}/`}
                      >
                        {eventToRender?.artist?.name}
                      </Link>
                    </td>
                    <td id={`name_${i}`} className="text-blue-500">
                      <Link
                        to={`/reports/events/${eventToRender.id}/sales/`}
                      >
                        {eventToRender?.name}
                      </Link>
                    </td>
                  
                    <td id={`city_${i}`}>{eventToRender?.city}</td>
                    <td id={`state_${i}`}>{eventToRender?.state}</td>
                    <td className="text-right" id={`gross_sales_${i}`}>
                      {eventToRender.gross_sales
                        ? eventToRender.gross_sales?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })
                        : 0?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                    </td>
                    <td className="text-right" id={`attendance_${i}`}>
                      {eventToRender.attendance &&
                        eventToRender.attendance?.toLocaleString()}
                    </td>
                    <td></td>
                    <td className="text-right pr-6" id={`per_head_${i}`}>
                      {eventToRender.attendance
                        ? (
                            eventToRender.gross_sales / eventToRender.attendance
                          )?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })
                        : 0?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : searchTimeout ? (
          <div className="mx-12 py-16">No events match the search</div>
        ) : (
          <div className="mx-12 py-16">
            Enter a search parameter or apply a filter to view results
          </div>
        )}
      </div>
    );
  };

  return (
    <SalesLayout>
      <div className="mt-10 mx-8 text-black bg-white rounded-lg border">
        {renderEventsTable()}
      </div>
      {events.length > 0 && (
        <footer className="text-sm mt-4 mx-8 pb-4 flex justify-between">
          <div className="ml-1 mr-8">
            Showing <span className="font-bold">{pagy.from} </span>to
            <span className="font-bold"> {pagy.to} </span>of
            <span className="font-bold"> {pagy.count} </span>results
          </div>
          <div className="mr-8">
            Page {pagy.page} of {pagy.last}
          </div>
          <div className="flex -mt-2">
            <span>
              <Button
                className={
                  pagy.page === 1
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={resetPagination}
                text="First"
                disabled={pagy.page === 1}
              ></Button>
            </span>
            <span className="mx-1">
              <Button
                value={pagy.prev}
                className={
                  !pagy.prev
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Prev"
                disabled={!pagy.prev}
              ></Button>
            </span>
            <span>
              <Button
                value={pagy.next}
                className={
                  !pagy.next
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Next"
                disabled={!pagy.next}
              ></Button>
            </span>
            <span className="ml-1">
              <Button
                value={pagy.last}
                className={
                  pagy.page === pagy.last
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Last"
                disabled={pagy.page === pagy.last}
              ></Button>
            </span>
          </div>
        </footer>
      )}
    </SalesLayout>
  );
};

export default EventComparison;
